<template>
  <div class="wrapper text-center">
    <h1>{{ errorTitle  }}</h1>
    <main class="container-xl login-area my-5">
      {{ errorMessage }}
    </main>
    <Button @click="returnTop">TOPへ戻る</Button>
  </div>
</template>

<script>
import { Button } from "components";

export default {
  name: "ErrorPage",
  components: {
    Button,
  },
  data() {
    return {
      errorTitle: "500 - Internal Server Error",
      errorMessage: "予期せぬエラーが発生しました。",
    };
  },
  async created() {
    const { errorId } = this.$route.params;
    if (errorId === "500") {
      this.errorTitle = this.$t("errorPages.500.title");
      this.errorMessage = this.$t("errorPages.500.message");
    } else if (errorId === "404") {
      this.errorTitle = this.$t("errorPages.404.title");
      this.errorMessage = this.$t("errorPages.404.message");
    }
  },
  methods: {
    returnTop() {
      this.$router.push("/");
    },
  },
};
</script>
